import PropTypes from 'prop-types'

export const questionPropType = PropTypes.shape({
    question: PropTypes.string.isRequired,
    image: PropTypes.string,
    answers: PropTypes.arrayOf(
        PropTypes.shape({
            answer: PropTypes.string.isRequired,
            result: PropTypes.shape({
                model: PropTypes.string.isRequired,
                value: PropTypes.shape({
                    data: PropTypes.object
                })
            }).isRequired
        })
    ).isRequired
}).isRequired

export const goalPropType = PropTypes.shape({
    title: PropTypes.string.isRequired,
    benefits: PropTypes.arrayOf(
        PropTypes.shape({
            benefit: PropTypes.object.isRequired
        })
    ).isRequired
})

export const getErrorMessage = (errors) => {
    return Object.entries(errors)
        .filter(([, hasError]) => hasError)
        .map(([key, error]) => `Failed to fetch ${key} data: ${error}`)
        .join(' ')
}
